import { render, staticRenderFns } from "./MSHeader.vue?vue&type=template&id=804b824c&"
import script from "./MSHeader.vue?vue&type=script&lang=js&"
export * from "./MSHeader.vue?vue&type=script&lang=js&"
import style0 from "./MSHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ganttboard/demo/project/ganttboard-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VSpacer,VToolbar,VToolbarTitle})
